import { render, staticRenderFns } from "./ProfessionsForExecutives.vue?vue&type=template&id=37e80fef&scoped=true"
import script from "./ProfessionsForExecutives.vue?vue&type=script&lang=js"
export * from "./ProfessionsForExecutives.vue?vue&type=script&lang=js"
import style0 from "./ProfessionsForExecutives.vue?vue&type=style&index=0&id=37e80fef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e80fef",
  null
  
)

export default component.exports